module.exports = __webpack_public_path__ + "img/ausstellung2.098f4c25.jpg";